<template>
   <div class="canvas-mask">
      <div class="close-btn" @click="$emit('closeSmartCanvas')">
         X
      </div>

      <div class="canvas-wrapper">
         <div id="smart_canvas_container">
         </div>
      </div>
   </div>

</template>

<script>
import {initSmartCanvas} from '@/smart_canvas/main.js';
import { mapActions, mapState } from 'vuex';

import {EventBus} from "./../../event-bus.js";

export default {
   data() {
      return {
         templateRecid: -1,
         scComponent: null
      }
   },

   mounted() {
      let smartCanvasContainer = document.getElementById('smart_canvas_container');
      this.scComponent = initSmartCanvas(smartCanvasContainer);

      let self = this;
      EventBus.$on('sc-edits-made', () => {
         // self.setUnsavedChanges({unsavedChanges: true});
      });

      this.openInstance({vm: this, instanceRecid: this.$route.params.id});
   },

   beforeDestroy() {
      this.scComponent.$destroy();
   },

   props: {
      instanceAssetRecid: Number | String,
   },

   methods: {
      ...mapActions('global', [
         'openInstance'
      ])
   }
}
</script>

<style lang="scss" scoped>
.canvas-mask {
   position: fixed;
   z-index: 9998;
   top: 0;
   left: 0;
   width: 100%;
   // max-width: 1920px;
   height: 100%;
   background-color: rgba(0, 0, 0, .9);
   // display: table;
   transition: opacity .3s ease;
   padding-left: 426px;
   padding-right: 25px;
}

.canvas-wrapper {
   // width: 73%;
   margin-top: 42px;
   // transform: scale(.75);
}

.close-btn {
   float: right;
   margin-right: 55px;
   margin-top: 18px;
   background: $error-red;
   border-radius: 30px;
   padding: 2px 6px;
   font-size: 12px;
   color: white;

   &:hover {
      cursor: pointer;
   }
}

.smart-canvas-container {
   // width: 72%;
   margin-left: 192px;
   max-width: 1368px;
   margin-left: 446px;
}

.overlay-mp-header {
   top: -84px;
   left: -207px;
   width: 126% !important;
}
.overlay-mp-menu {
   width: 400px;
   position: absolute;
   left: -207px;
   padding-top: 15px !important;

   .asset-table {
      max-height: 804px !important;
   }
}

</style>